import { useMemo } from "react";
import { AddressElement as StripeAddressElement } from "@stripe/react-stripe-js";
import type { StripeAddressElementOptions } from "@stripe/stripe-js";
import { usePaywallCheckoutContext } from "@/react/contexts/Paywalls/paywallCheckoutContext";
import { stripeElementsAddressElementModes } from "@circle-react/components/Paywalls/StripeElements/types";
import { useAddressElementDefaultValues } from "@circle-react/components/Paywalls/StripeElements/useAddressElementDefaultValues";
import { useAddressElementDisplay } from "@circle-react/components/Paywalls/StripeElements/useAddressElementDisplay";
import { useAddressElementFields } from "@circle-react/components/Paywalls/StripeElements/useAddressElementFields";
import { getCurrentUserName } from "../../../helpers/users";

export const AddressElement = () => {
  const {
    setMemberAddressAttributes,
    currentUser,
    memberBillingInfo: billingInfo,
  } = usePaywallCheckoutContext();

  const mode = stripeElementsAddressElementModes.billing;
  const defaultValues = useAddressElementDefaultValues({
    billingInfo,
    name: getCurrentUserName(currentUser),
  });
  const fields = useAddressElementFields();
  const display = useAddressElementDisplay();

  const options = useMemo<StripeAddressElementOptions>(
    () => ({
      mode,
      defaultValues,
      fields,
      display,
    }),
    [mode, defaultValues, fields, display],
  );

  return (
    <StripeAddressElement
      options={options}
      onChange={setMemberAddressAttributes}
    />
  );
};
